import {theme} from "Theme";
import {RouterUtil} from "base/navigation/utilities";
import {PERMIT_APPLICATION_STATUS} from "permitapplication/data";
import {usePermitExtensionProcessUrl} from "permitextension/hooks";
import {SubPageMenu, SubPageMenuListItemButton} from "base/ui/menu";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FolderOpenIconOutlined from "@mui/icons-material/FolderOpenOutlined";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";

const PermitExtensionSubPageMenu = ({extension}) => {
    const basePath = `/permits/extensions/list/${extension?.id}`;

    const {getStepPath} = usePermitExtensionProcessUrl(extension);

    const stepPath = getStepPath(extension, basePath);

    const stepResolvedPath = stepPath.slice(0, RouterUtil.getLastSlashIndex(stepPath));

    const headerSecondary = (
        <>
            <Stack
                sx={{
                    backgroundColor: "#ffe0b2",
                    borderRadius: 1,
                    p: 0.5,
                    mb: 0.5,
                }}
            >
                <Typography
                    color={
                        extension?.status === PERMIT_APPLICATION_STATUS.not_approved
                            ? theme.palette.error.dark
                            : theme.palette.primary.dark
                    }
                    fontSize={theme.typography.fontSize}
                    fontWeight={500}
                    lineHeight={1.25}
                >
                    {extension?.status || "Estado pendente"}
                </Typography>
            </Stack>
            <strong>{extension?.holder?.name || "Sem titular"}</strong> |{" "}
            {extension?.district || "Sem distrito"}
            {extension?.plot?.land_ownership &&
                ` | ${extension?.plot?.land_ownership.toUpperCase()}`}
        </>
    );

    return (
        <SubPageMenu
            headerTitle="Prorrogação"
            headerText={extension?.code}
            headerSecondary={headerSecondary}
        >
            <SubPageMenuListItemButton
                key="extension-summary"
                to={`${basePath}/summary`}
                text="Resumo"
                icon={<InfoOutlinedIcon />}
            />
            <SubPageMenuListItemButton
                key="extension-application-process"
                to={stepPath}
                resolvedPathName={stepResolvedPath}
                text="Processo de prorrogação"
                icon={<RestartAltOutlinedIcon />}
            />
            <SubPageMenuListItemButton
                key="extension-documents"
                to={`${basePath}/documents`}
                text="Documentos"
                icon={<FolderOpenIconOutlined />}
            />
        </SubPageMenu>
    );
};

export default PermitExtensionSubPageMenu;
